import { Box, Paper, Typography } from '@mui/material';
import { Description } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DocumentUpload } from './DocumentUpload';
import { OfferFormData } from '../types/offer.types';

interface DocumentSectionProps {
  existingDocuments?: { id: string; filename: string; fileSize: number; url: string }[];
  onDeleteExistingDocument?: (id: string) => void;
}

export function DocumentSection({
  existingDocuments,
  onDeleteExistingDocument,
}: DocumentSectionProps = {}) {
  const { t } = useTranslation();
  const { control } = useFormContext<OfferFormData>();

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <Box
          sx={{
            backgroundColor: 'primary.light',
            borderRadius: '16px',
            width: 44,
            height: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Description sx={{ color: 'white', fontSize: 24 }} />
        </Box>
        <Typography variant="h6" fontWeight={600}>
          {t('publish.documents.title')}
        </Typography>
      </Box>

      <Controller
        name="documents"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <DocumentUpload
            documents={field.value}
            onChange={field.onChange}
            maxDocuments={Number(import.meta.env.VITE_MAX_DOCUMENTS_PER_OFFER) || 5}
            maxSizeMB={Number(import.meta.env.VITE_MAX_DOCUMENT_SIZE_MB) || 20}
            existingDocuments={existingDocuments}
            onDeleteExisting={onDeleteExistingDocument}
          />
        )}
      />
    </Paper>
  );
}
